<template>
  <v-container fluid class="pa-0">
    <!-- 🔹 Header -->
    <v-app-bar color="primary" dark flat>
      <v-toolbar-title class="font-weight-bold">Messages</v-toolbar-title>
    </v-app-bar>

    <!-- 🔹 Chat List -->
    <v-list two-line v-if="conversations.length" >
      <v-list-item
        v-for="conv in conversations"
        :key="conv.id"
        @click="openConversation(conv)"
        class="chat-list-item py-3 px-2"
      >
        <!-- Avatar -->
        <v-list-item-avatar size="56">
          <v-img
            :src="getDefaultAvatar(conv)"
            class="rounded-circle elevation-2"
          ></v-img>
        </v-list-item-avatar>

        <!-- Chat Info -->
        <v-list-item-content>
          <!-- Partner name and profile tag -->
          <div class="d-flex align-center justify-space-between mb-1">
            <v-list-item-title class="font-weight-bold text-body-1">
              {{ getPartner(conv).name }}
            </v-list-item-title>
            <span class="text-caption grey--text">{{
              formatTime(conv.lastMessageAt)
            }}</span>
          </div>

          <!-- City, State -->
          <div
            v-if="getPartner(conv).city || getPartner(conv).state"
            class="text-caption grey--text text--darken-1"
          >
            {{ getPartner(conv).city || "" }}
            <span v-if="getPartner(conv).city && getPartner(conv).state"
              >,</span
            >
            {{ getPartner(conv).state || "" }}
          </div>

          <!-- Chat about profile -->
          <div
            v-if="conv.Profile"
            class="text-caption teal--text text--darken-2 mt-1 font-italic"
          >
            Chat about
            <strong>{{ conv.Profile.name }}</strong>
          </div>

          <!-- Last message -->
          <v-list-item-subtitle
            class="grey--text text--darken-2 text-truncate mt-1"
            v-text="conv.lastMessage || 'No messages yet'"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- 🔹 Empty State -->
    <v-alert
      v-if="!conversations.length && !loading"
      text
      color="primary"
      type="info"
      class="ma-5 text-center"
    >
      No active conversations yet. Start chatting with guardians or candidates
      to see them here.
    </v-alert>
  </v-container>
</template>

<script>
import chatService from "@/modules/Chat/service";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  data() {
    return {
      conversations: [],
      loading: true,
    };
  },
  async created() {
    await this.loadConversations();
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "currentOrganization",
      "globalStatus",
      "loadingStatus",
      "loginDialog",
    ]),
  },
  methods: {
    async loadConversations() {
      try {
        const res = await chatService.getAll();
        this.conversations = res.data || [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    getPartner(conv) {
      const currentUserId = this.currentUser.id;
      return conv.UserAId === currentUserId ? conv.UserB : conv.UserA;
    },
    formatTime(ts) {
      if (!ts) return "";
      const date = new Date(ts);
      const now = new Date();
      const sameDay = date.toDateString() === now.toDateString();
      return sameDay
        ? date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        : date.toLocaleDateString([], { month: "short", day: "numeric" });
    },
    getDefaultAvatar(conv) {
      const partner = this.getPartner(conv);
      return partner?.gender === "Female"
        ? require("@/assets/avatars/wife.png")
        : require("@/assets/avatars/brother.png");
    },
    openConversation(conv) {
      this.$router.push({
        name: "chat-conversation",
        params: { conversationId: conv.id },
      });
    },
  },
};
</script>

<style scoped>
.chat-list-item {
  border-bottom: 1px solid #eee;
}
.chat-list-item {
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.25s ease;
}
.chat-list-item:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}
.v-list-item__content {
  overflow: hidden;
}
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>